<template>
  <div class="checkbox-group">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  watch: {
    value() {
      this.updateChildren()
    }
  },
  mounted() {
    this.updateChildren()
  },
  methods: {
    updateCheck(value, options) {
      let arr = [...this.value]
      if (options.is_unique) {
        if (arr.includes(value)) {
          arr = []
        } else {
          arr = [value]
        }
      } else {
        this.options.map((item) => {
          if (item.is_unique) {
            let index = arr.indexOf(item.key)
            if (index >= 0) {
              arr.splice(index, 1)
            }
          }
        })

        let index = arr.indexOf(value)
        if (index >= 0) {
          arr.splice(index, 1)
        } else {
          arr.push(value)
        }
      }
      this.$emit('input', arr)
      this.$emit('change', arr, value)
    },
    updateChildren() {
      this.$children.forEach((item) => {
        item.checked = this.value
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
